import { Col, Row } from "react-bootstrap";
import { CrudPlaceholderInput } from "../../../../general/modules/commons/crud/inputs/crudPlaceholderInput";

export const RelationMutateFormTemplate = () => {
  return (
    <Row>
      <Col md="8">
        <CrudPlaceholderInput name="name" />
      </Col>
      <Col md="4">
        <CrudPlaceholderInput name="debtor_number" />
      </Col>
      <Col md="8">
        <CrudPlaceholderInput name="street" />
      </Col>
      <Col md="2">
        <CrudPlaceholderInput name="house_number" />
      </Col>
      <Col md="2">
        <CrudPlaceholderInput name="house_number_addition" />
      </Col>
      <Col md="4">
        <CrudPlaceholderInput name="postal_code" />
      </Col>
      <Col md="4">
        <CrudPlaceholderInput name="city" />
      </Col>
      <Col md="4">
        <CrudPlaceholderInput name="country" />
      </Col>
      <Col md="12">
        <CrudPlaceholderInput name="phone" />
      </Col>
      <Col md="12">
        <CrudPlaceholderInput name="dbb_api_identifier" />
      </Col>
      <Col md="12">
        <CrudPlaceholderInput name="invoice_type" />
      </Col>
      <Col md="12">
        <CrudPlaceholderInput name="invoice_product" />
      </Col>
    </Row>
  );
};
